import { ChevronDown, ChevronUp } from "lucide-react";

import type { SortKey, SortState } from "../sorting";

interface Props {
  label: string;
  sortKey: SortKey;
  sort: SortState;
  onSort: (key: SortKey) => void;
  /** Must carry the display utility (`inline-flex`, `hidden lg:inline-flex`, …) —
   * the base class deliberately sets none, so a column can be hidden per breakpoint
   * without two display classes fighting each other. */
  className?: string;
}

/** One clickable column header of the drive listing. */
export function SortHeader({ label, sortKey, sort, onSort, className = "inline-flex" }: Props) {
  const active = sort.key === sortKey;
  const Arrow = active && sort.dir === "desc" ? ChevronDown : ChevronUp;
  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      title={`Sortuj wg „${label}”`}
      aria-label={`Sortuj wg „${label}”`}
      className={`items-center gap-1 min-w-0 text-xs font-mono uppercase tracking-wider hover:text-[var(--color-primary)] ${
        active ? "text-[var(--color-text-primary)]" : "text-[var(--color-text-muted)]"
      } ${className}`}
    >
      <span className="truncate">{label}</span>
      <Arrow
        size={12}
        className={`flex-shrink-0 ${active ? "" : "opacity-0 group-hover:opacity-40"}`}
      />
    </button>
  );
}
